import { Service } from '@piwikpro/platform';

@Service()
export class FailedDependencyError extends Error {
  name = 'FailedDependencyError';

  errors = {};
}
